
import { Component, Prop, Vue } from "nuxt-property-decorator";

@Component({})
export default class SegmentedControl extends Vue {
  @Prop({ required: true }) options!: string[];
  @Prop({ default: 0 }) activeIndex!: number;
  @Prop({ default: "" }) panelId!: string;
  @Prop({ required: true }) tabIdPrefix!: string;

  getTabId(index: number): string {
    return `${this.tabIdPrefix}-${index}`;
  }
}
